module.exports = __webpack_public_path__ + "img/ic_button_deactive_dropdown_active_down.ac1e8341.svg";